import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=71f5d832&scoped=true"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=71f5d832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f5d832",
  null
  
)

export default component.exports